import { createSlice } from '@reduxjs/toolkit';

import { IState } from 'shared/interfaces/state.interface';
import { setOTPTokenToLocalStorage } from 'shared/utils/local-storage';
import { initialStore } from '../initial-store';

const authSlice = createSlice({
  name: 'auth',
  initialState: initialStore.auth,
  reducers: {
    setTwoFactorType: (state, { payload }) => {
      if (payload.user) {
        state.twoFATypeOptions = {
          email: payload.user.email,
          phone: payload.user.phone
        };
        setOTPTokenToLocalStorage(payload.token);
      }
    },
    change2FAType: (state, { payload }) => {
      state.twoFactorType = payload;
    }
  }
});

export const { setTwoFactorType, change2FAType } = authSlice.actions;

export const { reducer } = authSlice;

// Selectors
export const getTwoFactorAuthSelector = (state: IState) =>
  state && state.auth.twoFactorType;

export const getTwoFATypeOptionsSelector = (state: IState) =>
  state && state.auth.twoFATypeOptions;
